import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import React, { useRef, useState, useEffect } from "react";
import { useTheme } from "@emotion/react";
import { useChannel, useClickOutside, useModal, useFeatureFlags, useTranslation, } from "../../hooks";
import Modal from "../Ui/Modal/Modal";
import S from "./Message.styled";
import MessageActions from "./MessageActions";
import MessageWithAvatar from "./MessageWithAvatar";
import PlainMessage from "./PlainMessage";
import Tooltip from "../Ui/Tooltip/Tooltip";
const Message = ({ message, startsGroup, status, isChannelModerator, }) => {
    var _a, _b, _c;
    const { color } = useTheme();
    const emojiPickerRef = useRef(null);
    const theme = useTheme();
    const messageRef = useRef(null);
    const actions = [];
    const { isShown, toggle } = useModal();
    const strings = useTranslation();
    const channel = useChannel();
    const [editMessageId, setEditMessageId] = useState("");
    const [showPicker, setShowPicker] = useState(false);
    const flags = useFeatureFlags();
    useClickOutside(emojiPickerRef, () => setShowPicker(false));
    const [focused, setFocused] = useState(false);
    const currentUserIsTheSender = (channel === null || channel === void 0 ? void 0 : channel.currentUserId) &&
        (message === null || message === void 0 ? void 0 : message.serverId.length) &&
        message.senderId === (channel === null || channel === void 0 ? void 0 : channel.currentUserId);
    if (currentUserIsTheSender || isChannelModerator) {
        actions.push({
            id: "edit",
            icon: "edit",
            tooltip: "Edit",
            type: "normal",
            onClick: () => {
                setEditMessageId(message === null || message === void 0 ? void 0 : message.serverId);
            },
        });
    }
    if (flags.reactions) {
        actions.push({
            id: "emoji",
            icon: "emoji",
            tooltip: "Emoji",
            type: "normal",
            onClick: () => setShowPicker((v) => !v),
        });
    }
    if (flags.replies) {
        actions.push({
            id: "reply",
            icon: "reply",
            tooltip: "Reply",
            type: "normal",
            onClick: () => {
                channel.setReplyMessage(message);
                setFocused(false);
            },
        });
    }
    if (currentUserIsTheSender || isChannelModerator) {
        actions.push({
            id: "delete",
            icon: "delete",
            tooltip: "Delete",
            type: "danger",
            onClick: () => toggle(),
        });
    }
    const toggleEmoji = (emojiNative) => {
        var _a;
        const reaction = (_a = message.reactions) === null || _a === void 0 ? void 0 : _a.find((r) => { var _a; return r.emoji === emojiNative && ((_a = r.user) === null || _a === void 0 ? void 0 : _a.id) === channel.currentUserId; });
        if (reaction) {
            channel.deleteReaction(reaction);
        }
        else {
            channel.addReaction(emojiNative, message);
        }
    };
    const onKeyPress = (event) => {
        if (event.key === "Enter" && !focused) {
            setFocused(true);
        }
        else if (event.key === "Escape" && focused) {
            setFocused(false);
        }
    };
    const checkKeyDown = (e) => {
        if (!messageRef)
            return;
        if (!messageRef.current)
            return;
        let links = messageRef.current.querySelectorAll("a, button, input, textarea");
        let activeElement = document.activeElement;
        let newFocusIndex = -1;
        links === null || links === void 0 ? void 0 : links.forEach((link, index) => {
            if (link === activeElement) {
                newFocusIndex = index;
            }
        });
        switch (e.key) {
            case "Tab":
                e.shiftKey ? newFocusIndex-- : newFocusIndex++;
                break;
            case "ArrowRight":
                newFocusIndex++;
                break;
            case "ArrowLeft":
                newFocusIndex--;
                break;
            default:
                return;
        }
        e.stopPropagation();
        e.preventDefault();
        if (newFocusIndex > (links === null || links === void 0 ? void 0 : links.length)) {
            links[0].focus();
        }
        else if (newFocusIndex < 0) {
            links[links.length - 1].focus();
        }
        else if (!links[newFocusIndex]) {
            links[0].focus();
        }
        else {
            links[newFocusIndex].focus();
        }
    };
    useEffect(() => {
        if (!messageRef)
            return;
        if (!messageRef.current)
            return;
        if (focused) {
            messageRef.current.addEventListener("keydown", checkKeyDown, true);
        }
        else {
            messageRef.current.removeEventListener("keydown", checkKeyDown, true);
        }
        return () => {
            var _a;
            (_a = messageRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener("keydown", checkKeyDown, true);
        };
    }, [focused]);
    useEffect(() => {
        var _a, _b, _c;
        const activeElement = document.activeElement;
        if (focused &&
            (!activeElement || !((_a = messageRef.current) === null || _a === void 0 ? void 0 : _a.contains(activeElement)))) {
            (_b = messageRef.current) === null || _b === void 0 ? void 0 : _b.focus();
            (_c = messageRef.current) === null || _c === void 0 ? void 0 : _c.click();
        }
    }, [focused, document.activeElement]);
    const escapeEventPicker = (e) => {
        if (e.key === "Escape") {
            setShowPicker(false);
            setFocused(true);
        }
    };
    useEffect(() => {
        var _a, _b;
        if (showPicker) {
            setFocused(false);
            (_a = emojiPickerRef === null || emojiPickerRef === void 0 ? void 0 : emojiPickerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            (_b = emojiPickerRef === null || emojiPickerRef === void 0 ? void 0 : emojiPickerRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener("keydown", escapeEventPicker, true);
        }
        return () => {
            var _a;
            (_a = emojiPickerRef === null || emojiPickerRef === void 0 ? void 0 : emojiPickerRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener("keydown", escapeEventPicker, true);
        };
    }, [showPicker, focused]);
    return (React.createElement(S.OuterWrapper, { ref: messageRef, className: `outer-message ${focused && "focused"}`, tabIndex: 0, onKeyDown: onKeyPress, showActions: actions.length > 0 && focused },
        actions.length && !focused && (React.createElement(S.Enter, { id: "enter", className: "enter-text" }, "Enter")),
        actions.length && focused && (React.createElement(S.Enter, { id: "escape", className: "enter-text" }, "Esc")),
        React.createElement(S.Wrapper, { hasAvatar: startsGroup },
            startsGroup && (React.createElement(MessageWithAvatar, { message: message, status: status, editableMessageId: editMessageId, setEditableMessageId: setEditMessageId })),
            !startsGroup && (React.createElement(PlainMessage, { message: message, status: status, editableMessageId: editMessageId, setEditableMessageId: setEditMessageId })),
            actions && React.createElement(MessageActions, { actions: actions }),
            React.createElement(Modal, { isShown: isShown, hide: toggle, modalContent: strings.deleteConfirmation, headerText: strings.deleteModalTitle, handleDelete: () => {
                    channel === null || channel === void 0 ? void 0 : channel.removeMessage(message);
                    toggle();
                }, handleCancel: toggle }),
            React.createElement("div", { style: { position: "relative", zIndex: 100 } }, showPicker ? (React.createElement("div", { ref: emojiPickerRef, style: {
                    position: "absolute",
                    transform: "translateX(-100%)",
                    bottom: ((_b = (_a = messageRef === null || messageRef === void 0 ? void 0 : messageRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().top) !== null && _b !== void 0 ? _b : 0) +
                        510 >
                        window.innerHeight
                        ? "0"
                        : "unset",
                } },
                React.createElement(Picker, { theme: color.background === "#fff" ? "light" : "dark", data: data, onEmojiSelect: (emoji) => toggleEmoji(emoji.native), perLine: 6, onClick: () => setShowPicker(false), autoFocus: true }))) : null)),
        message.reactions && ((_c = message.reactions) === null || _c === void 0 ? void 0 : _c.length) > 0 ? (React.createElement(S.EmojiReactionWrapper, null, [
            ...message.reactions
                .reduce((acc, value) => {
                const userMap = acc.get(value.emoji);
                if (!value.user)
                    return acc;
                if (userMap) {
                    userMap.set(value.user.id, value.user);
                    acc.set(value.emoji, userMap);
                    return acc;
                }
                const initialMap = new Map();
                initialMap.set(value.user.id, value.user);
                acc.set(value.emoji, initialMap);
                return acc;
            }, new Map())
                .entries(),
        ].map(([emoji, usersMap]) => (React.createElement(Tooltip, { key: emoji, content: usersMap },
            React.createElement(S.EmojiReaction, { onClick: () => toggleEmoji(emoji), isEmojiSelected: usersMap.has(channel.currentUserId), theme: theme },
                emoji,
                React.createElement(S.EmojiReactionNumber, { isEmojiSelected: usersMap.has(channel.currentUserId) }, usersMap.size))))))) : null));
};
export default Message;
//# sourceMappingURL=Message.js.map